import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { employeeFields, RouteInfo } from 'src/app/modules/campaign/campaign';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'app-create-campaigns',
  templateUrl: './create-campaigns.component.html',
  styleUrls: ['./create-campaigns.component.css']
})
export class CreateCampaignsComponent implements OnInit {
  
  addCampaignForm: FormGroup;

  public shiftData = [];
  public branchData = [];
  public routeData = []; //RouteInfo;
  public routeList = [];

  matFormSize = '12px';
  public fieldOptions={
    campaignType:[
      {value:'sms',name:'Sms'},
      {value:'call',name:'Call'},
      {value:'email',name:'Email'},
      {value:'push notifications',name:'Push Notifications'},
    ],
    campaignFor:[
      {value:'regular',name:'Regular Routes'},
      {value:'occasional',name:'occasional Routes'},
    ],
    transitMode:[
      {value:'Pickup',name:'Pickup Routes'},
      {value:'Drop',name:'Drop Routes'},
    ],
    branch:[],
    shift:[],
    availableTemplate:[],
  }
  finalCheck:Boolean=false;   
  createTemplate:Boolean=false;   
  templateCreation:Boolean = false;

  public activeIndex;
  public activeSelection={};
  public activePickup;
  public activePickupSelection={};

  public routeTableData = [];
  public noRouteData:boolean = false;

  getSelectedEmpList = {};
  public selectedEmployees = {};
  public closePopup: boolean = true;

  public userData;
  public page = 1;

  public showSchedule:boolean = false;
  public enableDateTime: boolean = true;
  public scheduleDate;
  public defaultSDate = new Date();

  constructor(
    public router: Router,
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    private loader: LoaderService,
    private comservice: CommonServices,){
      this.userData = this.storage.get('userInfo')
     }
  ngOnInit(): void {
    this.setupList();
    this.getRouteData();
    this.getShiftData();
    this.getBranchData();
    this.getAvailableTemplate();
    this.addCampaignsLoad()
  }

  addCampaignsLoad() {
    this.addCampaignForm = new FormGroup({
      campaignName: new FormControl('', [Validators.required]),
      campaignFor: new FormControl('', [Validators.required]),
      campaignType: new FormControl('', [Validators.required]),
      transitMode: new FormControl('', [Validators.required]),
      branch: new FormControl('', [Validators.required]),
      shift: new FormControl('', [Validators.required]),
      routeInfo: new FormControl('',[Validators.required]),
      templateName: new FormControl('', [Validators.required]),
      templateMessage: new FormControl('', [Validators.required]),
    });
  }

  getShiftData() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      // console.log(res);
      if (res.status == 'success') {
        this.shiftData=res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getBranchData() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if(res.data && res.data.length>0){
          this.branchData = res.data;
          res.data.filter((e)=>{
            let option={name:e.branchName,value:e.branchID};
            this.fieldOptions['branch'].push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getAvailableTemplate(){
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerCampaignTemplateList(obj).then((res: any) => {
      if (res.status == 'success') {
        res.data.filter((e)=>{
           let option = { name: e.title, value:e.title, message:e.message };
           this.fieldOptions['availableTemplate'].push(option);
        })
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getRouteData(){
    //  this.api.transportMangerRouteList
    this.api.transportMangerRouteList({}).then((res:any)=>{
         if(res.status == 'success'){
          this.routeData = res.data;
          this.noRouteData = true;
          this.setupList();
         }
    }).catch((err) => {
      console.log(err);
    });
  }

  getPickupList(route,index) {
    let obj = {
      orgID:route.orgID,
      routeID:route.routeID,
    };

    this.api.listRoutePickupPoint(obj).then((res:any)=>{
      if(res.status =='success'){
        this.routeTableData[index]['vehicleInfo'] = res.data;
        console.log(this.routeTableData);
        this.setupPickupPoints(index);
        this.loader.hide();
        /*  this.pickupPoints = res.data[0].pickupInfo;
         this.pickupPoints.map((item)=>{
               item.eta = (''+item.eta).replace('.',':');
               return item;
         }); */
     }
    });
  }

  setupPickupPoints(index){
    this.routeTableData[index]['vehicleInfo'].filter((item)=>{
      item.pickupInfo.filter((e)=>{
        e['checked'] = this.routeTableData[index].checked;
        e['indeterminate'] = false;

        e.employees.filter((emp)=>{
          emp['checked'] = e.checked;
          emp['indeterminate'] = false;
        });

      })
    });
  }


  setupList(){
    this.routeTableData = [];
    this.routeData.filter((e)=>{
      let result = {
        orgID : e.orgID,
        title : e.title,
        routeID : e.routeID,
        trasitMode: e.trasitMode,
        startTime:this.getTimeString(e.startTime),
        checked:false,
        indeterminate:false,
        vehicle:e.vehicle,
      };
      this.routeTableData.push(result);
    });
    console.log('set up list',this.routeTableData);
    setTimeout(()=> this.noRouteData = true ,10);
  }

  getTimeString(time){                             // time '10:20'
    let timeString=String(time);
    let splitTime=timeString.split(".");            // 10, 20
    splitTime[1] = splitTime[1]==undefined ? '0' : splitTime[1];
    
    let hour = this.comservice.pad(Number(splitTime[0]));
    let minute = this.comservice.pad(Number(splitTime[1]));
   
    let timeformat = `${hour}:${minute}`;
    return timeformat;
  }

  fieldChange(value,field){
    if (field == 'campaignFor') {
      let transitValue = this.addCampaignForm.value.transitMode;
      if(transitValue) this.filterTransitMode(transitValue);
      else this.filterRoutes(value);
    }
    if (field == 'transitMode') this.filterTransitMode(value);
    if (field == 'branch') this.onChangeBranch(value);
    if (field == 'availableTemplate') this.optionChange(value);
  }

  filterRoutes(value){
    this.allSelectRoute(false);
    this.routeTableData = [];
    this.routeData.filter((e)=>{
      if(value.includes(e.routeType)){
        let result = {
          orgID : e.orgID,
          title : e.title,
          routeID : e.routeID,
          trasitMode: e.trasitMode,
          startTime:this.getTimeString(e.startTime),
          checked:false,
          indeterminate:false,
          vehicle:e.vehicle,
        };
        this.routeTableData.push(result);
      }
    });

  }
  
  filterTransitMode(value){
    this.addCampaignForm.controls.campaignFor.markAsTouched();
    this.filterRoutes(this.addCampaignForm.value.campaignFor);
    this.routeTableData = this.routeTableData.filter((e)=> value.includes(e.trasitMode));
  }


  optionChange(val){
    let value = val.target.value;
    this.fieldOptions['availableTemplate'].filter((e)=>{ 
      if(e.value == value) this.addCampaignForm.controls['templateMessage'].patchValue(e.message);
    });

  }
  
  onChangeBranch(val) {
    this.fieldOptions['shift'] = [];
    this.shiftData.filter((e)=>{
      if (val.includes(e.branch)) {
        let branchName = '';
        if(this.fieldOptions['branch']) {
          this.fieldOptions['branch'].filter((branch)=>{
            if(branch.value == e.branch) branchName = branch.name;
          });
        }
        let option= { name:this.titleCaseString(e.shiftName)+'-'+this.titleCaseString(branchName), value:e.shiftID};
        this.fieldOptions['shift'].push(option);
      }
    });
  }

  titleCaseString(val){
    if (val) return val[0].toUpperCase() + val.substr(1).toLowerCase();
  }


  // toggle all route selection
  allSelectRoute(value){

      this.routeTableData.filter((e,index)=>{
        e.checked = value;
        if (value) e.indeterminate = !value;
        if (!value) e.indeterminate = value;
        this.routeSelectAll(value,index);
      });

  }

  // check all route checked
  checkAllRouteChecked(){
    let result = true;
    this.routeTableData.filter((e)=>{ if( !e.checked || e.indeterminate) result=false;})
    return result;
  }

  checkAllRouteIndeterminate(){

    if (this.routeTableData.length == 0) {
      return false;
    }
    return this.routeTableData.filter(e => e.checked || e.indeterminate).length > 0 && !this.checkAllRouteChecked();

  }

  // check route pickupPoints checked or not    route.indeterminate

  checkRouteChecked(index){
    let checked = true;
    this.routeTableData[index].vehicleInfo.filter((vehicle)=>{
      if(vehicle.pickupInfo.length > 0 ){
        
        vehicle.pickupInfo.filter((pickupPoint)=>{
          if (!pickupPoint.checked) checked = false;
        });
        
      }
    });
    
    this.routeTableData[index].checked = checked;

  }
  
  checkRouteIndeterminate(index){
    let indeterminate = false;
    this.routeTableData[index].vehicleInfo.filter((vehicle)=>{
      if(vehicle.pickupInfo.length > 0 ){
        
        vehicle.pickupInfo.filter((pickupPoint)=>{
          if (!this.routeTableData[index].checked && pickupPoint.checked) indeterminate = true;
        });
        
      }
    });
    
    this.routeTableData[index].indeterminate = indeterminate;
  }

  routeSelectAll(value,index){

    this.routeTableData[index].checked = value;
    if (value) this.routeTableData[index].indeterminate = !value;
    if (!value) this.routeTableData[index].indeterminate = value;

    if (this.routeTableData[index].vehicleInfo && this.routeTableData[index].vehicleInfo.length > 0){
      
      this.routeTableData[index].vehicleInfo.filter((vehicle,vehicleIndex)=>{
        if(vehicle.pickupInfo.length > 0 ){
          
          vehicle.pickupInfo.filter((pickupPoint,pickupPointIndex)=>{
            this.togglePickupPoint(value,index,vehicleIndex,pickupPointIndex);
          });

        }
        else return;
      });

    }
    else return;

  }

  // check pickup point toggle

  checkPickupPointChecked(routeIndex,vehicleIndex,pickupPointIndex){
    let checked = true;
    this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].employees.filter((employee)=>{
          if (!employee.checked) checked = false;
        });
        
        this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].checked = checked;
  }
  
  checkPickupPointIndeterminate(routeIndex,vehicleIndex,pickupPointIndex){
    let indeterminate = false;
    this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].employees.filter((employee)=>{

      if (!this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].checked && employee.checked) indeterminate = true;
      
    });
    
    this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].indeterminate = indeterminate;
  }



  togglePickupPoint(event,routeIndex,vehicleIndex,pickupPointIndex){
    this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].checked = event;
    if(event) this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].indeterminate = !event;
    if(!event) this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].indeterminate = event;

    this.routeTableData[routeIndex].vehicleInfo[vehicleIndex].pickupInfo[pickupPointIndex].employees.filter((emp,empIndex)=>{
      this.toggleEmployee(event,routeIndex,vehicleIndex,pickupPointIndex,empIndex);
    });
/* 
    this.checkRouteChecked(routeIndex);
    this.checkRouteIndeterminate(routeIndex); */

  }

  toggleEmployee(event,routeIndex,vehIndex,PpIndex,EmpIndex){

    this.routeTableData[routeIndex].vehicleInfo[vehIndex].pickupInfo[PpIndex].employees[EmpIndex].checked = event;
    if(event) this.routeTableData[routeIndex].vehicleInfo[vehIndex].pickupInfo[PpIndex].employees[EmpIndex].indeterminate = !event;
    if(!event) this.routeTableData[routeIndex].vehicleInfo[vehIndex].pickupInfo[PpIndex].employees[EmpIndex].indeterminate = event;

    this.checkPickupPointChecked(routeIndex,vehIndex,PpIndex);
    this.checkPickupPointIndeterminate(routeIndex,vehIndex,PpIndex);

    this.checkRouteChecked(routeIndex);
    this.checkRouteIndeterminate(routeIndex);

  }

  patchRouteInfo(){
    let value = [];
    console.log(this.routeTableData.length);
    if( this.routeTableData.length > 0){
      
      let allRoute:boolean = this.routeData.length == this.routeTableData.length;
      value = [ ...this.routeTableData ];
      
      if ( allRoute && this.checkAllRouteChecked() ) value = ['allRoutes'];         // check all routes selecte

      if ( !allRoute && this.checkAllRouteChecked() ) value.filter((route)=> { delete route['vehicleInfo']; }); 

      if (this.checkAllRouteIndeterminate()) {
      
        value.filter((route,routeIndex)=> {
          console.log(route.checked,route.indeterminate,routeIndex);
          if (!route.checked && !route.indeterminate){
            value.splice(routeIndex,1); 
          }
        });

        if(value.length > 0){

          value.filter((route,routeIndex)=> { 

            if(route.checked && route['vehicleInfo']) delete route['vehicleInfo'];

            else if(route.indeterminate) {
              if (route.vehicleInfo.length > 0){

                route.vehicleInfo.filter((vehicle,vehIndex)=>{

                  value[routeIndex].vehicleInfo[vehIndex]['selectedEmp'] = []; //
                  vehicle.pickupInfo.filter((pickupPoint)=>{ //,ppIndex

                    pickupPoint.employees.filter((employee)=>{
                      if ( employee.checked ) value[routeIndex].vehicleInfo[vehIndex]['selectedEmp'].push(employee.employeeID); 
                    })

                    /* if (pickupPoint.checked) delete value[routeIndex].vehicleInfo[vehIndex].pickupInfo[ppIndex].employees;
                    else if (pickupPoint.indeterminate){  

                      if (pickupPoint.employees.length > 0){

                        pickupPoint.employees.filter((employee,empIndex)=>{
                          if ( employee.checked ) value[routeIndex].vehicleInfo[vehIndex]['employees'].push(employee);
                          if (!employee.checked && !employee.indeterminate) value[routeIndex].vehicleInfo[vehIndex].pickupInfo[ppIndex].employees.splice(empIndex,1); 
                        });     
                      }
                    }
                    else value[routeIndex].vehicleInfo[vehIndex].pickupInfo.splice(ppIndex,1); */
                  });
                });
              }
            }
            else value.splice(routeIndex,1);
          });
        }
      }
    }
    this.addCampaignForm.controls['routeInfo'].patchValue(value);
  }

  getSelectedEmployees(obj: any) {
    console.log('Emp selected ', obj);
    this.selectedEmployees = obj;
    for (let key in obj) {
      this.getSelectedEmpList[key] = true;
    }
    this.closePopup = true;
  }
  deleteAllEmp() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.selectedEmployees = {};
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  }
  deleteSelectedPickEmp(key: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        delete this.getSelectedEmpList[key];
        delete this.selectedEmployees[key];
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  }


  /* Expand Table */
  expandMore(index){
    if(this.routeData.length>0){
      let obj=this.routeTableData[index];
      this.activeSelection=obj;
      console.log('obj',obj);
      if (obj.vehicleInfo == undefined) {
        this.loader.show();
        this.getPickupList(obj,index);
      }
      else{
        this.checkRouteChecked(index);
        this.checkRouteIndeterminate(index);
      }
      this.activeIndex=index;
    }
  }
  expandLess(){
    this.activeIndex=undefined;
    this.activeSelection={};
    this.employeeHide();
  }

  // Employees Details
  employeeShow(val,index){
    if(val.employees.length > 0){
      this.activePickup = index;
      this.activePickupSelection = val;
    }
  }
  employeeHide(){
    this.activePickup = undefined;
    this.activePickupSelection = {};
  }

  

  templateChange(type){
    if(type == 'create'){
      this.templateCreation = true;
      this.createTemplate = true;
      this.clearTemplateData();
    }
    else{
      this.createTemplate = false;
      this.templateCreation = false;
      this.clearTemplateData();
    }
  }
  clearTemplateData(){
    this.addCampaignForm.controls['templateName'].patchValue('');
    this.addCampaignForm.controls['templateName'].markAsUntouched();
    this.addCampaignForm.controls['templateMessage'].patchValue('');
    this.addCampaignForm.controls['templateMessage'].markAsUntouched();
  }

  toggleSchedule(type){
    this.scheduleDate = undefined;
    if(type=='open') this.showSchedule = true;
    else this.showSchedule = false;
  }
  
  //date picker
  dateFromAction(obj: any = {}) {
    console.log(obj.selectedDates);
    this.scheduleDate = obj.selectedDates;
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.addCampaignForm.controls[controlName].hasError(errorName);
  }


  onSubmit(){  
    this.patchRouteInfo();
    this.finalCheck = true;         
    console.log('final obj',this.addCampaignForm.value);

    if(this.addCampaignForm.valid){
      let obj = {
        orgID: this.userData.orgID,
        ...this.addCampaignForm.value,
      };      
      console.log(obj);
    }
  }

   /* Cancel Add Campaign*/

   cancel(){
    this.router.navigate(['/organization/transport-manager/campaigns/view-campaigns']);
  }

}
